import imageUrlBuilder from "@sanity/image-url";
import React from "react";

import { Text } from "@/components/elements/Text";
import styles from "@/components/LandingPage/styles.module.css";
import SubcategoriesGrid from "@/components/SubcategoriesGrid";
import { client } from "@/sanity/lib/client";

import { Product, ProductsSectionProps } from "./types";

export const ProductsSection = ({ title, products }: ProductsSectionProps) => {
  // Sanity image builder
  const builder = imageUrlBuilder(client());
  function urlFor(source) {
    return builder.image(source);
  }

  return (
    <section className={styles.discoverProductsSection}>
      <Text
        as="h2"
        size="l"
        responsive
        className={styles.discoverProductsTitle}
      >
        {title}
      </Text>
      <SubcategoriesGrid>
        {products.map((product: Product) => (
          <SubcategoriesGrid.Card
            className={styles.explorpafyllGridCard}
            key={product.link}
            as="li"
            imgSrc={urlFor(product.image).url()}
            slug={product.link}
            text={product.title}
            logos={product.logos}
          />
        ))}
      </SubcategoriesGrid>
    </section>
  );
};
